import "react-circular-progressbar/dist/styles.css";

import { useEffect } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { Controller } from "react-hook-form";

import tickicon from "../../../src/assets/images/tickicon.svg";
import useEmailVerification from "../../hooks/useEmailVerification";
import { cn } from "../../utils/utils";
import Loader from "../shared/Loader";
import OtpInput from "../shared/OtpInput/OtpInput";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const LoaderIcon = () => (
  <div className="w-8 h-8">
    <Loader />
  </div>
);

const EmailInput = ({ name, label, errors, className, control }) => {
  const {
    timer,
    setTimer,
    otp,
    setOtp,
    otpIsVisible,
    emailStatus,
    loadingSendingEmail,
    loadingVerifyEmail,
    handleSendEmail,
    handleVerifyEmail,
  } = useEmailVerification();

  const isCountingDown = timer > 0;

  useEffect(() => {
    if (timer <= 0) return;
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timer, setTimer]);

  return (
    <div className={cn("col-span-1 flex flex-col gap-2", className)}>
      <label htmlFor={name}>{label}</label>

      <div className="flex gap-2">
        <Controller
          control={control}
          name={name}
          rules={{
            required: "Email is required",
            pattern: { value: emailRegex, message: "Invalid email format" },
          }}
          render={({ field: { onChange, value } }) => {
            const email = value ?? "";
            const isInvalid = !!errors?.[name] || !emailRegex.test(email);

            return (
              <>
                <input
                  autoFocus={false}
                  className="flex-1 h-[52px] text-[14px] md:text-[16px] px-4 outline-none rounded-v-md w-full border border-neutral-30"
                  placeholder="ایمیل خود را وارد کنید"
                  type="text"
                  value={email}
                  onChange={(e) => onChange(e.target.value)}
                />
                <button
                  type="button"
                  disabled={isCountingDown || isInvalid}
                  onClick={() => handleSendEmail(email)}
                  className="relative p-2 bg-dark disabled:bg-neutral-30 px-4 h-full flex-center rounded-xl text-white text-[14px] md:text-[16px]"
                >
                  {loadingSendingEmail ? (
                    <LoaderIcon />
                  ) : (
                    <div className="flex gap-2">
                      {isCountingDown && (
                        <div style={{ width: 20, height: 20 }}>
                          <CircularProgressbar
                            value={timer}
                            maxValue={120}
                            strokeWidth={30}
                            styles={buildStyles({ trailColor: "#d6d6d6" })}
                          />
                        </div>
                      )}
                      <p>{isCountingDown ? `${timer} ثانیه` : "تایید ایمیل"}</p>
                    </div>
                  )}
                </button>
              </>
            );
          }}
        />
      </div>

      {errors?.[name] && (
        <span className="text-red-500 text-[12px] md:text-[16px]">{errors[name].message}</span>
      )}

      {otpIsVisible && isCountingDown && (
        <div className="flex flex-col gap-2 md:flex-row md:justify-between bg-neutral-20 md:bg-white p-2 md:p-0">
          <div className="flex flex-col md:flex-row gap-1 md:gap-3 md:items-center">
            <p>کد ارسال شده را وارد نمایید </p>
            <OtpInput value={otp} valueLength={5} onChange={setOtp} />
          </div>
          <button
            type="button"
            onClick={handleVerifyEmail}
            className="bg-dark h-full flex-center rounded-xl text-white py-2 px-4 md:min-w-[80px]"
          >
            {loadingVerifyEmail ? <LoaderIcon /> : "تایید کد"}
          </button>
        </div>
      )}

      {emailStatus === "approved" && (
        <div className="flex gap-1 items-center mt-2">
          <img src={tickicon} alt="tick icon" />
          <p>ایمیل مورد تایید است</p>
        </div>
      )}

      {emailStatus === "denied" && (
        <div className="flex gap-1 items-center mt-2 text-red-500 text-[12px] md:text-[16px]">
          <p> رمز وارد گردیده صحیح نمی باشد. لطفا پس از اتمام زمان دوباره تلاش کنید.</p>
        </div>
      )}
    </div>
  );
};

export default EmailInput;
